import React from "react";
import "./index.less";
import { Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
const { Title, Paragraph, Text } = Typography;

const ContentPolicyPage = () => {
  const { t } = useTranslation();
  let listArr = [
    ["any-individual-under-age-text", "any-other-person-unless-you-have-text"],
    [
      "firearms-weapons-or-any-goods-whose-sale-text",
      "drugs-or-drug-paraphernalia",
      "self-mutilation-or-suicide",
      "incest;",
      "bestiality;",
      "violence-rape-lack-of-consent-hypnosis-text",
      "necrophilie;",
      "urinary-scatological-or-excrement-related-material",
      "revenge-porn-text",
      "escort-services-sex-trafficking-text",
    ],
    ["contains-unsolicited-sexual-content-text", "contains-promotes-advertises-or-refers-text", "contains-or-refers-to-anyone-else's-personal-text"],
    ["in-the-case-of-content-depicting-text", "in-the-case-of-content-depicting-sexual-text"],
    ["gives-the-impression-that-text", "causes-or-is-calculated-to-cause-text", "is-used-or-is-intended-to-text"],
  ];

  const list2Arr = [
    [
      "all-content-when-uploaded-by-text",
      "any-content-containing-a-text",
      "similarly-if-a-creator-proposes-content-text",
      "any-dispute-or-uncertainty-during-text",
      "once-the-content-has-been-published-text",
      "finally-in-line-with-its-status-as-a-hosting-provider-text",
    ],
    [
      "regarding-the-verification-of-creators-age-text",
      "with-regard-to-the-integrity-of-consent-text",
      "using-an-artificial-intelligence-solution-text",
      "if-a-creator-uploads-content-featuring-text",
      "twizz-requires-that-any-agency-presenting-text",
      "when-it-comes-to-verifying-the-age-of-users-text",
    ],
    ["has-entered-into-a-formal-contract-text", "has-signed-the-present-anti-exploitation-policy"],
    ["inform-your-line-manager-or-the-head-text", "please-contact-text"],
    [
      "declaration-18-usc-2257",
      "twizz-is-not-the-producer-text",
      "twizz-is-a-social-network-that-allows-text",
      "twizz-follows-the-following-procedures-text",
      "require-all-creator-users-text",
      "for-help-and-or-information-text",
      "twizz-allows-its-users-to-report-text",
      "twizz-users-who-encounter-this-text",
    ],
  ];

  return (
    <div className="PolicyPagesCommonWrapper">
      <HomePageNavbarComponent />
      <Row justify="center" className="ContentPolicyPageWrapper">
        <Row className="terms-main">
          <Title level={3} className="term-head">
            {t("content-policy-title")}
          </Title>
          <Paragraph className="term-comman">{t("document-published-by-twizz-text")}</Paragraph>
          <Row className="lists-container">
            <ol className="term-comman">
              <li>{t("shows-includes-or-refers-to")}</li>
            </ol>
            <ul className="show-disply term-comman show-type">
              {listArr[0].map((item, index) => {
                return <li>{t(item)}</li>;
              })}
            </ul>
            {/* **************************************** */}
            <ol className="term-comman">
              <li>{t("shows-promotes-advertises-or-refers-to")}</li>
              <li className="list-display">
                <ol className="show-disply">
                  {listArr[1].map((item) => {
                    return <li value={1}>{t(item)}</li>;
                  })}
                </ol>
              </li>
            </ol>
            {/* ******************************************* */}
            <ol className="show-disply term-comman">
              {listArr[2].map((item, index) => {
                return <li value={1}>{t(item)}</li>;
              })}
            </ol>
            {/* ***************************************** */}
            <ol className="term-comman">
              <li>either :</li>
              <li className="list-display">
                <ol className="show-disply">
                  {listArr[3].map((item, index) => {
                    return <li>{t(item)}</li>;
                  })}
                </ol>
              </li>
            </ol>
            {/* **************************************** */}
            <ol className="show-disply term-comman">
              {listArr[4].map((item, index) => {
                return <li value={1}>{t(item)}</li>;
              })}
            </ol>
          </Row>
          {/* ****************************** */}
          <Paragraph className="term-comman">{t("any-breach-of-these-obligations-text")}</Paragraph>
        </Row>
        {/* ****************************************** */}
        <Row className="terms-main">
          <Title level={3} className="term-head mm">
            {t("process-for-fighting-illegal-content")}
          </Title>
          <Paragraph className="term-comman">{t("twizz-is-particularly-committed-to-combating-text")}</Paragraph>
          {/* **************************** */}
          <ol className="show-disply term-comman">
            <li className="term-spe-list">
              <ol className=" show-disply term-comman">
                <li value={1}>{t("twizz-certifies-any-user-wishing-text")}</li>
                <li className="term-spe-list twizz-li">{t("thanks-to-this-certification-text")}</li>
                {list2Arr[0].map((item, index) => {
                  return <li value={1}>{t(item)}</li>;
                })}
              </ol>
            </li>
          </ol>
        </Row>
        {/* ************************************** */}
        <Row className="terms-main">
          <Title level={3} className="term-head mm">
            {t("policy-to-prevent-minors-from-accessing-title")}
          </Title>
          <Paragraph className="term-comman">{t("twizz-mission-has-always-been-to-prevent-text")}</Paragraph>
          {/* **************************** */}
          <ol className="show-disply term-comman">
            <li className="term-spe-list">
              <ol className=" show-disply term-comman">
                {/* <li value={1}>{t("regarding-the-verification-of-creators-age-text")}</li> */}
                {/* <li className='term-spe-list'>Thanks to this certification, twizz can identify any author of potentially illicit content and, if necessary, initiate the necessary proceedings.</li> */}
                {list2Arr[1].map((item, index) => {
                  return (
                    <li value={1} className={`${index == 2 || index == 3 || index == 4 ? "circle" : ""}`}>
                      {t(item)}
                    </li>
                  );
                })}
              </ol>
            </li>
          </ol>
        </Row>

        {/* ************************************* */}
        <Row className="terms-main">
          <Title level={3} className="term-head mm">
            {t("anti-exploitation-policy")}
          </Title>
          <Paragraph className="term-comman">{t("this-document-is-published-by-twizz-text")}</Paragraph>
        </Row>
        {/* **************************************** */}
        <Row className="terms-main">
          <Title level={3} className="term-head ">
            {t("anti-slavery-policy-statement")}
          </Title>
          <Paragraph className="term-comman">{t("modern-slavery-is-a-crime-and-a-violation-text")}</Paragraph>
          <Paragraph className="term-comman ">
            <Text className="term-head ">{t("policy-responsibility")} </Text>
            {t("twizz-has-overall-responsibility-for-text")}
          </Paragraph>
          <Paragraph className="term-comman ">
            <Text className="term-head ">{t("details-of-this-policy-towards-designers")} </Text>
            {t("twizz-intends-to-combat-any-form-of-human-text")}
          </Paragraph>
          <Paragraph className="term-comman ">1. {t("subjects-each-creator-to-a-certification-process")}</Paragraph>
          <Paragraph className="term-comman ">{t("all-creator-candidates-must-provide-proof-text")}</Paragraph>
          <Paragraph className="term-comman ">2. {t("requires-any-third-party-appearing-in-text")}</Paragraph>
          <Paragraph className="term-comman ">{t("twizz-seeks-to-ensure-that-any-person-text")}</Paragraph>
          <ol>
            <ul className="show-disply term-comman">
              {list2Arr[2].map((item, index) => {
                return <li className="circle">{t(item)}</li>;
              })}
            </ul>
          </ol>
          <Paragraph className="term-comman">{t("the-same-applies-to-ambassadors-registered-text")}</Paragraph>
          <Paragraph className="term-comman ">
            <Text className="term-head ">{t("policy-compliance")} </Text>
            {t("you-must-ensure-that-you-read-text")}
          </Paragraph>
          <Paragraph className="term-comman ">
            <Text className="term-head ">{t("communicating-and-raising-awareness-of-this-policy-text")}</Text>
            {t("any-employee-ambassador-or-designer-text")}
          </Paragraph>
          <Paragraph className="term-comman ">
            <Text className="term-head ">{t("disclosures")}</Text>
            {t("if-you-believe-or-suspect-that-a-text")}{" "}
          </Paragraph>
          <ol>
            <ul className="show-disply term-comman">
              {list2Arr[3].map((item, index) => {
                return <li className="circle">{t(item)}</li>;
              })}
            </ul>
          </ol>
          <Paragraph className="term-comman ">
            <Text className="term-head ">{t("violation-of-this-policy")}</Text>
            {t("any-employee-who-breaches-this-policy-text")}
          </Paragraph>
        </Row>
        {/* **************************************** */}
        <Row className="terms-main">
          <Title level={3} className="term-head ">
            {t("child-protection-policy")}
          </Title>
          <Paragraph>
            {list2Arr[4].map((item, index) => {
              return <Paragraph className="term-comman">{t(item)}</Paragraph>;
            })}
          </Paragraph>
        </Row>
        {/* ****************************************** */}
      </Row>
    </div>
  );
};

export default ContentPolicyPage;
